import axios from "axios";
import api from "./";

export default {
    /**
     * Get booking requests
     * @param userId
     * @param params
     */
    getBookingRequests(userId, params) {
        return api
            .get(`/users/${userId}/bookingRequests`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get cards authorizations.
     * @param userId
     * @param params
     */
    getCardAuthorizations(userId, params) {
        return api
            .get(`/users/${userId}/cardAuthorizations`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get cards.
     * @param userId
     * @param params
     */
    getCards(userId, params) {
        return api
            .get(`/users/${userId}/cards`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Create card.
     * @param userId
     * @param data
     */
    createCard(userId, data) {
        return api.post(`/users/${userId}/cards`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Get cards transactions.
     * @param userId
     * @param params
     */
    getCardTransactions(userId, params) {
        return api
            .get(`/users/${userId}/cardTransactions`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get credit cards.
     * @param userId
     * @param params
     */
    getCreditCards(userId, params) {
        return api
            .get(`/users/${userId}/creditCards`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get expense requests
     * @param userId
     * @param params
     */
    getExpenseRequests(userId, params) {
        return api
            .get(`/users/${userId}/expenseRequests`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get allowances
     * @param userId
     * @param params
     */
    getAllowances(userId, params) {
        return api
            .get(`/users/${userId}/allowances`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get licenses of users
     * @param userId
     * @param params
     */
    getLicenses(userId, params) {
        return api
            .get(`/users/${userId}/licenses`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get notifications
     * @param userId
     * @param params
     */
    getNotifications(userId, params) {
        return api
            .get(`/users/${userId}/notifications`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get payment transactions of user
     * @param userId
     * @param params
     */
    getPaymentTransactions(userId, params) {
        return api
            .get(`/users/${userId}/paymentTransactions`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get permissions of user
     * @param userId
     * @param params
     */
    getPermissions(userId, params) {
        return api
            .get(`/users/${userId}/permissions`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Set permissions to user
     * @param userId
     * @param data
     */
    setPermissions(userId, data) {
        return api
            .post(`/users/${userId}/permissions`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get roles of user
     * @param userId
     * @param params
     */
    getRoles(userId, params) {
        return api
            .get(`/users/${userId}/roles`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Set roles to user
     * @param userId
     * @param data
     */
    setRoles(userId, data) {
        return api.post(`/users/${userId}/roles`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Set token for user
     * @param userId
     * @param data
     */
    setToken(userId, data) {
        return api.post(`/users/${userId}/tokens`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Get list of wallets
     * @param userId
     * @param params
     */
    getWallets(userId, params) {
        return api
            .get(`/users/${userId}/wallets`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Create wallet
     * @param userId
     * @param data
     */
    createWallet(userId, data) {
        return api.post(`/users/${userId}/wallets`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Get list of users
     * @param params
     */
    get(params) {
        return api
            .get(`/users`, {
                params: {
                    isCancellable: true,
                    ...params,
                },
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Create user
     * @param data
     */
    create(data) {
        return api.post(`/users`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Show user
     * @param userId
     * @param params
     */
    show(userId, params) {
        return api
            .get(`/users/${userId}`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Update user
     * @param userId
     * @param data
     */
    update(userId, data) {
        return api.put(`/users/${userId}`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Delete user
     * @param userId
     */
    delete(userId) {
        return api.delete(`/users/${userId}`).then((response) => {
            return response.data;
        });
    },

    /**
     * Get bookings
     * @param userId
     * @param params
     */
    getBookings(userId, params) {
        return api
            .get(`/users/${userId}/bookings`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Update media of the user
     * @param userId
     * @param data
     * @param config
     */
    addMedia(userId, data, config) {
        return api
            .post(`/users/${userId}/medias`, data, config)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get payment methods of users
     * @param userId
     * @param params
     */
    getPaymentMethods(userId, params) {
        return api
            .get(`/users/${userId}/paymentMethods`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Set an initial password to the user
     * @param userId
     * @param data
     */
    setInitialPassword(userId, data) {
        return api
            .post(`/users/${userId}/initialPassword`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Send welcome mail.
     * @param userId
     * @param data
     */
    sendWelcomeMail(userId, data) {
        return api
            .post(`/users/${userId}/sendWelcomeMail`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * resend welcome mail.
     * @param userId
     * @param data
     */
    resendWelcomeMail(userId, data) {
        return api
            .post(`/users/${userId}/resendWelcomeMail`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Send group admin welcome mail.
     * @param userId
     * @param data
     */
    sendGroupAdminWelcomeMail(userId, data) {
        return api
            .post(`/users/${userId}/sendGroupAdminWelcomeMail`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Enable user.
     * @param userId
     * @param data
     */
    enable(userId, data) {
        return api.post(`/users/${userId}/enable`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Disable user.
     * @param userId
     * @param data
     */
    disable(userId, data) {
        return api.post(`/users/${userId}/disable`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Check if a user exists
     * @param params
     */
    exists(params) {
        return api
            .get(`/users/exists`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get user opts
     * @param userId
     * @param params
     */
    getOpts(userId, params) {
        return api
            .get(`/users/${userId}/opts`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Set user opts
     * @param userId
     * @param data
     */
    setOpts(userId, data) {
        return api.post(`/users/${userId}/opts`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Get list of groups
     * @param params
     */
    getGroups(userId, params) {
        return api
            .get(`/users/${userId}/groups`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * get old user emails
     * @param userId
     */
    getOldEmails(userId) {
        return api.get(`/users/${userId}/emails`).then((response) => {
            return response.data;
        });
    },

    /**
     * delete user email
     * @param userId
     * @param emailId
     */
    deleteEmail(userId, emailId) {
        return api
            .delete(`/users/${userId}/emails/${emailId}`)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get wallet transactions of a user
     * @param userId
     * @param params
     */
    getWalletTransactions(userId, params) {
        return api
            .get(`/users/${userId}/walletTransactions`, { params })
            .then(response => {
                return response.data
            })
    },
    /**
     *
     * Merge a user to another one
     * @param {String} userId - ID of the user to merge (origin)
     * @param {Object} data
     * @param {String} data.to - ID of the user to be merged into (target)
     */
    merge(userId, data) {
        return api.post(`/users/${userId}/merge`, data).then((response) => {
            return response.data;
        });
    },
};
